import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'

import { getBrowserLocale } from '@/services/i18n'

let defaultState = {
  isAuthenticated: false,
  currentUser: null,
  locale: getBrowserLocale({ countryCodeOnly: true })
}

let vuexState = localStorage.getItem('vuexState') ?
    JSON.parse(localStorage.getItem('vuexState')) : null

let state = vuexState && vuexState.auth || defaultState

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
